import { Box, Card, Divider, Icon, Typography } from "@drone-js/core";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { CallToAction } from "./CallToAction";
import { PropertyContent } from "./PropertyContent";
import { Skeleton } from "./Skeleton";
import { useCompletePagePropertyViewModel } from "./useCompletePagePropertyViewModel";

export const WhatsNext = () => {
    const {
        cmsData: {
            complete: {
                whatsNextText,
                letUsDoAFinalReviewText,
                weWillSendAnEmailText,
                optimizeYourListingText,
                syncYourCalendarsAndDetailsText,
            },
        },
    } = useStaticDataAtomValue();
    const { publishedListing } = useCompletePagePropertyViewModel();

    return (
        <Box mb="32">
            <Typography variant="heading-l" mb="16" textColor="base.default">
                {whatsNextText}
            </Typography>
            <Card type="non-interactive" variant="outlined" p="24" data-element-name="what-next-section">
                {publishedListing === null ? <Skeleton /> : <PropertyContent {...publishedListing} />}
                <Divider direction="horizontal" my="24" />
                <Box display="flex">
                    <Icon id="line.symbol.doc-check" size="32" />
                    <Box ms="16">
                        <Typography variant="heading-default" textColor="base.default">
                            {letUsDoAFinalReviewText}
                        </Typography>
                        <Typography variant="body-default" textColor="base.subtle" mt="8">
                            {weWillSendAnEmailText}
                        </Typography>
                    </Box>
                </Box>
                <Box display="flex" my="24">
                    <Icon id="line.symbol.home-check" size="32" />
                    <Box ms="16">
                        <Typography variant="heading-default" textColor="base.default">
                            {optimizeYourListingText}
                        </Typography>
                        <Typography variant="body-default" textColor="base.subtle" mt="8">
                            {syncYourCalendarsAndDetailsText}
                        </Typography>
                    </Box>
                </Box>
                <CallToAction />
            </Card>
        </Box>
    );
};
